module.exports = __webpack_public_path__ + "static/stars-618c7a6bf03e99a65646e9f7b4d4d28b.svg";